import { Box } from '@mui/material'
import { LoadingRows as BaseLoadingRows } from 'components/Loader/styled'
import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px;
`

export const MaxButton = styled.button<{ width: string }>`
  padding: 8px 12px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.backgroundInteractive};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  overflow: hidden;
  color: ${({ theme }) => theme.textSecondary};
  :hover {
    border: 1px solid ${({ theme }) => theme.primaryBorder};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.primaryBorder};
    outline: none;
  }
`

export const Dots = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
`

export const LoadingRows = styled(BaseLoadingRows)`
  padding-top: 36px;
  min-width: 75%;
  max-width: 100%;
  grid-column-gap: 0.5em;
  grid-row-gap: 0.8em;
  grid-template-columns: repeat(3, 1fr);
  padding: 8px;

  & > div:nth-child(4n + 1) {
    grid-column: 1 / 3;
  }
  & > div:nth-child(4n) {
    grid-column: 3 / 4;
    margin-bottom: 2em;
  }
`
